<template>
  <div>
    <el-card shadow="always">
      <div class="container">
        <h1>智能招聘辅助系统 - 产品说明</h1>
        <p>本演示项目基于 <span class="highlight">AI 技术</span>，旨在解决招聘领域的两大核心难题：<strong>简历结构化存储</strong>与<strong>智能匹配评分</strong>。</p>

        <h2>核心功能</h2>
        
        <h3>1. 智能简历解析与结构化存储</h3>
        <p>系统能够自动解析格式各异的简历文件（PDF、Word等），并将信息结构化存储到数据库中：</p>
        <ul>
            <li><strong>个人信息：</strong>姓名、性别、年龄、联系方式等</li>
            <li><strong>教育背景：</strong>学校、学历、专业、毕业时间等</li>
            <li><strong>工作经历：</strong>公司名称、职位、工作内容等</li>
            <li><strong>技能认证：</strong>编程语言、证书、项目经验等</li>
            <li><strong>求职意向：</strong>目标职位、期望薪资等</li>
        </ul>
        <p><strong>技术亮点：</strong>NLP 技术、数据标准化。</p>

        <h3>2. 智能岗位匹配与自动评分</h3>
        <p>系统通过 AI 深度理解岗位需求，并对候选人进行评分匹配：</p>
        <ul>
            <li><strong>需求拆解：</strong>分析职位描述，提取岗位要求</li>
            <li><strong>简历评分：</strong>基于技能匹配度、经验匹配度、教育背景等进行评分</li>
            <li><strong>推荐最佳候选人：</strong>提供排名列表，HR 可直接查看最优人选</li>
        </ul>
        <p><strong>技术亮点：</strong>NLP 语义分析、机器学习评分模型、可视化匹配报告。</p>

        <h2>应用场景</h2>
        <ul>
            <li><strong>企业招聘：</strong>提高 HR 的简历筛选效率</li>
            <li><strong>猎头公司：</strong>快速匹配人才，提升推荐精准度</li>
            <li><strong>求职平台：</strong>优化推荐算法，提升用户体验</li>
        </ul>

        <h2>总结</h2>
        <p>本系统通过 <span class="highlight">AI 技术</span>，为招聘行业提供智能解决方案。未来可结合面试反馈数据，进一步优化匹配精准度，提高企业招聘效率！🚀</p>
    </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'Dashboard',
};
</script>